import { underscore } from '@ember/string';

import ApplicationSerializer from './application';

export default class QuoteSerializer extends ApplicationSerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }

  keyForRelationship(key) {
    return underscore(key);
  }

  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    payload.data.attributes.subtotal = payload.data.attributes.subtotal?.value;
    payload.data.attributes.vat_amount = payload.data.attributes.vat_amount?.value;
    payload.data.attributes.stamp_duty_amount = payload.data.attributes.stamp_duty_amount?.value;

    return super.normalizeResponse(store, primaryModelClass, payload, id, requestType);
  }
}
